import { BookingPhase } from '@/components/Booking/models/BookingPhase';

export class BookingPhases {

    static Undefined: BookingPhase = new BookingPhase(0, "Undefined");
    static NotStarted: BookingPhase = new BookingPhase(1, "NotStarted");
    static AlmostStarted: BookingPhase = new BookingPhase(2, "AlmostStarted");
    static Ongoing: BookingPhase = new BookingPhase(3, "Ongoing");
    static AlmostEnded: BookingPhase = new BookingPhase(4, "AlmostEnded");
    static Ended: BookingPhase = new BookingPhase(5, "Ended");
    
    static States = [
        BookingPhases.Undefined,
        BookingPhases.NotStarted,
        BookingPhases.AlmostStarted,
        BookingPhases.Ongoing,
        BookingPhases.AlmostEnded,
        BookingPhases.Ended,
    ]
    
    klass: object = BookingPhases;
}

export default BookingPhase;
